<template>
  <div class="table-list">
    <el-table
        :height="tableHeight"
        size="medium"
        ref="table"
        v-bind="$attrs"
        v-on="$listeners"
        :stripe="stripe"
        :header-cell-style="headerCellStyle"
        :border="border" >
      <slot></slot>
    </el-table>

    <el-pagination
        v-if="showPage"
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pager.pageIndex"
        :page-sizes="pageSizes"
        :page-size="pager.pageSize"
        :layout="pageLayout"
        :total="total">
    </el-pagination>
  </div>
</template>

<script>

import {filterParams, resetEmpty, scrollToTop} from "../../utils/common";

export default {
  name: "TableList",
  props: {
    stripe: { // 是否为斑马纹 table
      type: Boolean,
      default: true
    },
    searchParams: { // 动态搜索参数 （请求时会自动过滤值为空的请求参数）
      type: Object,
      default: () => {
        return {}
      }
    },
    requestParams: { // 固定请求参数 （请求时会自动过滤值为空的请求参数）
      type: Object,
      default: () => {
        return {}
      }
    },
    auto: { // 是否在页面初始化完后自动触发请求
      type: Boolean,
      default: true,
    },
    pageLayout: { //  分页布局
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    pageSizes: { // 每页显示个数选择器的选项设置
      type: Array,
      default: () => {
        return [10, 30, 80, 100, 500, 1000]
      }
    },
    showPage: { // 是否显示分页
      type: Boolean,
      default: true,
    },
    backTop: { // 是否在请求完成后自动返回顶部
      type: Boolean,
      default: true,
    },
    headerCellStyle: { //  表头单元格样式
      type: Object,
      default: () => {
        return {
          background: '#E5F1FE',
          color: '#333333',
        }
      }
    },
    border: { //  是否带有纵向边框
      type: Boolean,
      default: true,
    },
    onPage: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pager: {
        pageIndex: 1,
        pageSize: this.pageSizes[0],
      },
      total: 0,

      // 首次加载数据需要延缓一下计算容器高度
      isFirstLoad: true,
    }
  },
  mounted() {
    if(this.auto) this.handleRequest();
  },
  methods: {
    // 获取dom
    getDom(type = 'table') {
      let dom = {
        "table": this.$refs.table,
        "page": this.$refs.page,
      }
      return dom[type] || null;
    },

    // 重置
    reset() {
      return resetEmpty(this.searchParams);
    },

    handleSearch() {
      this.pager.pageIndex = 1;
      this.handleRequest();
    },

    /**
     *  请求数据
     * @param delCount 如果是删除操作则传入删除条数，可以用来判断是否需要减去一页
     * @emits params 请求参数
     * @emits setTotal 设置总数 回调函数
     */
    handleRequest(delCount = 0) {

      let params = {
        ...this.searchParams,
        ...this.requestParams,
      }

      if(this.onPage) {
        if(delCount > 0) {
          // 如条数不足当前页码所显示则自动减去一页
          // 防止删除数据后无数据显示
          let {pageSize, pageIndex} = this.pager;
          let nowPageIndex = Math.ceil((this.total - delCount) / pageSize);
          if(pageIndex > 1 && nowPageIndex < pageIndex) {
            this.pager.pageIndex --;
          }
        }
        params = Object.assign(params, this.pager);
      } else {
        params["onPage"] = false;
      }

      if(this.backTop) {
        scrollToTop(this);
      }

      /**
       *  请求数据
       *  @param params 请求参数
       *  @param setTotal 设置总条数
       */
      if(this.isFirstLoad) {
        setTimeout(() => {
          this.$emit('query', filterParams(params), this.setTotal);
        }, 200)
        this.isFirstLoad = false;
        return;
      }
      this.$emit('query', filterParams(params), this.setTotal);
      this.$refs.table.doLayout();
    },


    // 设置total
    setTotal(total) {
      if(typeof total !== 'number') {
        throw  new Error('total必须为数字');
      }
      this.total = total;
    },

    handleSizeChange(size) {
      this.pager.pageSize = size;
      this.handleRequest();
    },
    handleCurrentChange(page) {
      this.pager.pageIndex = page;
      this.handleRequest();
    },
  },
  computed: {
    tableHeight() {
      if(this.height <= 0) return null;
      return this.height - 50;
    },
  }
}
</script>

<style scoped>

.table-list {
  height: 100%;
  display: flex;
  flex-direction: column;
}


.el-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}

</style>
